import React, {useEffect, useState} from 'react'
import SecretKeyTextField from "../SecretKeyTextField"
import {GroqCloudJson} from "../../../api/json/IntegrationJson"
import {IntegrationSettingsFormProps} from "./IntegrationSettingsFormProps"
import {ModelPlatform} from "../../../api/enum/ModelPlatform"

interface GroqCloudSettingsFormProps extends IntegrationSettingsFormProps {
    groqCloud: GroqCloudJson | null
}

function GroqCloudSettingsForm({groqCloud, onChange}: GroqCloudSettingsFormProps) {
    const [secretKey, setSecretKey] = useState<string>(groqCloud?.secretKey ?? "")
    const [isValidSecretKey, setIsValidSecretKey] = useState(true)

    useEffect(() => {
        if (secretKey === "") return

        const isValidSecretKey = secretKey.length >= 56 && secretKey.startsWith("gsk_")
        setIsValidSecretKey(isValidSecretKey)

        const isValid = isValidSecretKey

        const unsavedChanges = !groqCloud || (secretKey !== "" && secretKey !== groqCloud.secretKey)

        onChange({
            platform: ModelPlatform.GROQ_CLOUD,
            id: groqCloud?.id ?? null,
            secretKey: secretKey,
        }, isValid, unsavedChanges)
    }, [secretKey])

    return (
        <>
            <SecretKeyTextField label="API key"
                                value={secretKey}
                                setValue={setSecretKey}
                                valid={isValidSecretKey}
            />
        </>
    )
}

export default GroqCloudSettingsForm